function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_731_63)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M176.346 18.452C124.024 -6.31585 125.263 -6.31585 72.0121 19.3807C19.9997 44.7677 20.6189 43.8389 7.61582 101.424C-4.76809 158.08 -5.38728 156.842 31.4548 202.972C67.9873 247.864 66.7489 247.554 125.882 247.554C183.777 246.935 182.538 247.554 219.381 201.424C255.294 155.913 254.984 157.152 241.981 99.5665C228.668 43.2198 229.597 44.1486 176.346 18.452Z",
  fill: "#E73B52"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.8912 154.985L52.1977 197.09L57.7705 196.78L63.3432 179.443L77.5847 180.681L85.9438 197.09L92.4454 196.471L71.3928 154.365L64.8912 154.985ZM64.5816 176.656L69.2256 162.415L76.6559 176.347L64.5816 176.656Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.8202 122.786C97.0895 115.356 77.2753 100.805 46.9347 101.115V150.96C84.0864 150.96 93.9935 136.099 65.8202 122.786ZM54.365 119.071C54.365 114.737 54.365 110.402 54.0554 106.068C85.6344 108.545 76.0369 120.31 54.365 119.071ZM54.0554 145.697V128.05C89.3496 131.145 78.8232 146.935 54.0554 145.697Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.306 155.604L116.285 155.294L115.046 105.139H141.052L141.981 96.1611L76.6561 98.6379L76.3465 104.83L107.925 105.139L107.306 155.604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.3215 93.9938L74.1791 46.935L64.5816 47.2446L64.8912 94.3034L72.3215 93.9938Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.152 50.3406L172.322 74.1796L170.464 97.0898H176.656V73.87L194.613 50.3406L186.563 50.031L174.799 70.1548L163.653 50.031L157.152 50.3406Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.613 94.3035L103.591 93.9939L102.353 57.1518L128.359 57.4614L129.288 48.1735L78.2044 50.6503V56.8422L95.2322 57.1518L94.613 94.3035Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.866 108.855L120.309 111.022V116.594L141.362 116.904L140.743 162.415L148.792 162.105L147.554 116.904L159.938 117.214L160.866 108.855Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.266 91.2075L146.316 90.8979L145.387 45.6966L168.607 46.0062L169.536 37.6471L110.712 39.8143V45.6966H138.885L138.266 91.2075Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.894 151.579V122.477L200.495 93.065L190.588 92.7554L175.727 118.142L161.795 92.7554L153.746 93.065L172.941 123.096L170.464 151.889L177.894 151.579Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.99 159.938C187.801 159.938 191.826 162.415 193.374 166.13C195.541 166.13 197.399 165.82 199.566 165.82C196.47 159.319 190.588 156.223 181.3 156.533C168.916 156.842 165.201 162.105 165.201 164.582C165.201 168.607 169.845 173.87 180.99 174.18C187.182 174.489 192.445 176.037 192.445 181.61C192.445 185.635 189.659 187.492 183.777 187.802C176.346 188.111 172.941 184.396 170.774 180.062C172.322 172.322 158.39 163.963 135.789 166.749C136.099 181.92 136.408 197.09 136.718 211.951C137.956 211.951 139.504 211.951 140.743 211.641C140.743 204.52 141.052 197.709 141.052 190.588C154.984 190.588 163.653 187.802 167.678 184.396C170.774 188.731 175.727 191.517 183.157 191.827C192.755 192.136 198.947 188.421 198.947 181.61C198.947 175.418 192.755 171.703 181.3 170.464C176.037 170.155 172.941 167.988 172.941 164.272C173.25 161.486 175.418 159.938 180.99 159.938ZM165.82 180.062C163.653 184.087 154.365 187.183 141.362 184.396V172.632C161.486 170.774 168.297 175.728 165.82 180.062Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.9223 163.034C95.2319 180.062 95.8511 197.09 96.1607 214.118C97.7087 214.118 99.2567 213.808 100.805 213.808C101.114 206.068 101.114 198.019 101.424 190.279C153.127 189.969 139.195 158.081 94.9223 163.034ZM101.114 182.848C101.114 178.204 101.114 174.18 101.424 169.536C144.148 165.821 132.693 189.04 101.114 182.848Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.5633 112.26L86.8729 159.319L94.3033 159.009L96.1609 111.95L86.5633 112.26Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_731_63"
}, /*#__PURE__*/React.createElement("rect", {
  width: 250,
  height: 247.554,
  fill: "white"
})));

var SvgIbaIconPositive = function SvgIbaIconPositive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 248,
    viewBox: "0 0 250 248",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIbaIconPositive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iba_icon_positive.d6824795.svg";
export { ForwardRef as ReactComponent };